import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;
const supabase = createClient(supabaseUrl, supabaseKey);

export default function Lesson() {
  const { id } = useParams();
  const [lesson, setLesson] = useState({
    studentName: null,
    description: null,
    tasks: [],
  });
  const [completedTasks, setCompletedTasks] = useState([]);
  const [index, setIndex] = useState(0);
  const [candyCoins, setCandyCoins] = useState(0);
  const [homeworkCompleted, setHomeworkCompleted] = useState(false);

  const fetchLesson = async () => {
    const { data, error } = await supabase
      .from("lessons")
      .select()
      .eq("id", id);
    return data;
  };

  const handleTaskCompletion = (index) => {
    setCompletedTasks((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  useEffect(() => {
    const getLesson = async () => {
      const data = await fetchLesson();
      setLesson({
        studentName: data[0]["studentName"],
        description: data[0]["description"],
        tasks: data[0]["tasks"],
      });
      setCompletedTasks(new Array(data[0]["tasks"].length).fill(false));
    };
    getLesson();
  }, []);

  const completedTasksCount = completedTasks.filter((task) => task).length;

  const calculateCandyCoins = () => {
    const percentageCompleted = (completedTasksCount / lesson.tasks.length) * 100;
    let coins = 0;
    if (percentageCompleted >= 50) {
      coins = 1;
    }
    if (percentageCompleted === 100) {
      coins = 2;
    }
    if (homeworkCompleted) {
      coins += 1;
    }
    return coins;
  };

  const addHomeworkPoint = (event) => {
    setHomeworkCompleted(event.target.checked);
  };

  useEffect(() => {
    setCandyCoins(calculateCandyCoins());
  }, [completedTasks, homeworkCompleted]);

  const incrementIndex = () => {
    if (index < lesson.tasks.length - 1) {
      setIndex(index + 1);
    }
  };

  const decrementIndex = () => {
    if (index > 0) {
      setIndex(index - 1);
    }
  };

  return (
    <div
      id="lesson"
      style={{ minHeight: "75vh", width: "55vw" }}
      className="mt-10 overflow-hidden bg-white shadow rounded-lg"
    >
      <div className="px-6 py-8 sm:px-6">
        <h3 className="text-3xl font-semibold leading-7 text-gray-900">
          Hi, {lesson.studentName}! :)
        </h3>
      </div>
      <div className="border-t border-gray-100">
        <dl className="divide-y divide-gray-100">
          <div
            className="px-4 py-6 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6 justify-center items-center"
            style={{ gridTemplateColumns: "1fr 2fr" }}
          >
            <div>
              <dt className="text-lg font-medium text-gray-900">Description</dt>
            </div>
            <dt className="text-base font-normal text-gray-900">
              {lesson.description}
            </dt>
          </div>

          <div
            className="px-4 py-6 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6 justify-center items-center"
            style={{ gridTemplateColumns: "1fr 2fr" }}
          >
            <div>
              <dt className="text-lg font-medium text-gray-900">Tasks</dt>
            </div>
            <dt>
              <div>
                <div
                  className="flex flex-col items-start justify-around"
                  style={{ minHeight: "10vh" }}
                >
                  <p>{lesson.tasks[index]}</p>
                  <input
                    type="checkbox"
                    checked={completedTasks[index] || false}
                    onChange={() => handleTaskCompletion(index)}
                  ></input>
                </div>
                <div className="mt-4">
                  <button
                    onClick={decrementIndex}
                    className="rounded-full bg-white px-2.5 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  >
                    Previous
                  </button>
                  <button
                    onClick={incrementIndex}
                    className="rounded-full bg-white px-2.5 py-1 ml-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            </dt>
          </div>

          <div
            className="px-4 py-6 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-6 justify-center items-center"
            style={{ gridTemplateColumns: "1fr 2fr" }}
          >
            <div>
              <dt className="text-lg font-medium text-gray-900">Progress</dt>
            </div>
            <dt className="text-base font-normal flex flex-col text-gray-900">
              <meter
                className="w-1/2 h-12"
                value={completedTasksCount}
                max={lesson.tasks.length}
              ></meter>
              <label>
                <input
                  className="mr-2"
                  type="checkbox"
                  onClick={addHomeworkPoint}
                />
                Homework Completed?
              </label>
              <p>You have earned: {candyCoins}/3 possible candy coins</p>
            </dt>
          </div>
        </dl>
      </div>
    </div>
  );
}

/*
    <div
      style={{ minHeight: "85vh" }}
      className="bg-white rounded-md w-2/3 flex flex-col justify-around items-center px-16"
    >
      <h1 className="text-4xl font-semibold">Lesson</h1>
      <p className="text-xl">{lesson.description}</p>
      <ul>
        <p className="text-center text-2xl font-semibold">Tasks:</p>
        {lesson.tasks.map((task, index) => (
          <div key={index} className="flex flex-row">
            <li>{task}</li>
            <input
              type="checkbox"
              onChange={() => handleTaskCompletion(index)}
            ></input>
          </div>
        ))}
      </ul>
      <div className="w-full flex flex-col justify-center items-center">
        <p>Progress:</p>
        <meter
          className="w-1/2 h-12"
          value={completedTasksCount}
          max={lesson.tasks.length}
        ></meter>
      </div>
      <p>You have earned: {candyCoins}/3 possible candy coins</p>
    </div>
  );
}
*/
